const withInertiaStopped = (fn) => {
  const html = document.documentElement, prevOverflowHTML = html.style.overflow
  const body = document.body, prevOverflowBody = body.style.overflow
  html.style.overflow = 'hidden'
  body.style.overflow = 'hidden'
  setTimeout(() => {
    html.style.overflow = prevOverflowHTML
    body.style.overflow = prevOverflowBody
    fn()
  }, 50)
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    static threshold = 450;
    static opacityPadding = 50;


    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }

      const gallery = this.querySelector('.product__media-list')
      const children = gallery.querySelectorAll('li')
      const dotContainer = this.querySelector('.container-dot')
      children.forEach(() => {
        const dot = document.createElement('span')
        dot.classList.add('dot')
        dotContainer.appendChild(dot)
      })
      const height = gallery.offsetHeight
      const scrollPosition = gallery.scrollTop
      const position = Math.round(scrollPosition / height);

      if(dotContainer.querySelectorAll('span')[position]) {
        dotContainer.querySelectorAll('span')[position].classList.add('active')
      }

      gallery.addEventListener('scroll', (event) => {
        scrollCheckDot(gallery, dotContainer)
      }, { passive: true })

      const scrollCheckDot = (gallery, dotContainer) => {
        const height = gallery.offsetHeight
        const scrollPosition = gallery.scrollTop
        const scrollHeight = gallery.scrollHeight
        const position = Math.round(scrollPosition / height)

        this.productInfo = this.closest(".product-packaged").querySelector('.product__info-wrapper');
        this.mediaProduct = this.closest(".product-packaged").querySelector('.product__media-wrapper')
        this.slideAlert = this.closest(".product-packaged").querySelector('.slide-alert');
        const isLastPosition = scrollPosition + height >= scrollHeight - 1

        if (isLastPosition) {
          console.log('ultima posicion');
          this.slideAlert ? this.slideAlert.classList.remove('hidden') : '';
          
          setTimeout(() => {
            this.productInfo.classList.add("animate__animated", "animate__bounce", "animate__slow");
          }, 2000);

        } else {
          console.log('no es ultima posicion');
          this.slideAlert ? this.slideAlert.classList.add('hidden') : '';
          if (this.productInfo.classList.contains('animate__animated')) {
            this.productInfo.classList.remove('animate__animated', 'animate__bounce', 'animate__slow');
          }
        }

        dotContainer.querySelector('.active')?.classList.remove('active')
        dotContainer.querySelectorAll('span')[position]?.classList.add('active')
      }

      this.mql = window.matchMedia('(min-width: 750px)');
      if (this.elements.thumbnails) {
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      const parentProduct = this.closest(".main-product")
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
var touchMoveEvent = new Event('touchmove');
